export default "__VITE_ASSET__42JKtoqH__"